import React from "react";
import ImageModule from "../../../modules/image_module";

const ClientLogo = ({data}) => {
    return (<>
        {data?.client_logos?.length > 0 &&
            <div className="brand-wrap">
                {data?.client_logos?.map((item, index) =>{
                    if(item.client_logo){
                        return(
                            <a href={item.link ? item.link : "javascript:;"} target={item.link ? "_blank" : "_self"}>
                                <ImageModule ImageSrc={item.client_logo} width={item.client_logo.width} height={item.client_logo.height} />
                            </a>
                        )
                    }                    
                })}
            </div>
        }
    </>)
}
export default ClientLogo;